import { AppContextType } from 'marketplace-ui-common/types';
import PortalIdParser from 'PortalIdParser';
import ReviewFilters from '../records/ReviewFilters';
import { ReviewType } from '../types';
import { useReviews } from './useReviews';

interface useGetEditableReviewsProps {
  appContext: AppContextType;
  entityId: number;
  reviewType: ReviewType;
  reviewerUserId?: number;
  skip?: boolean;
}

export function useGetPreviousReviews({
  appContext,
  entityId,
  reviewType,
  reviewerUserId,
  skip,
}: useGetEditableReviewsProps) {
  const { reviews, reviewsFetchStatus } = useReviews({
    appContext,
    offeringId: entityId,
    reviewFilters: new ReviewFilters({
      reviewTypes: [reviewType],
      entityId: appContext === 'public' ? undefined : entityId,
      reviewerPortalId: PortalIdParser.get(),
      reviewerUserId,
    }),
    reviewType,
    skip,
  });

  return {
    reviews,
    reviewsFetchStatus,
  };
}
